import Admin from 'api/Admin'
import React, { useEffect, useState } from 'react'
import FormRow from './FormRow'
import useForm from 'js/hooks/useForm'

export default function Step2({ onChange, payload }) {

    const [schema, setSchema] = useState([])
    const [loading, setLoading] = useState(true)
    const { purpose, purpose_data } = payload

    const getPurpose = async () => {
        try {
            const res = await Admin.Case.getPurposeFields({ display_label: purpose })
            setSchema(res)
        } catch (error) {
            alert(error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (purpose) {
            getPurpose()
        }
    }, [])


    if (loading) {
        return "Loading..."
    }

    if (schema.length) {
        return <Form schema={schema} purpose_name={purpose} payload={purpose_data} onChange={onChange} />
    }

}


const Form = ({ schema, payload, purpose_name, onChange }) => {

    const { data, inputProps, setData } = useForm({ schema })


    useEffect(() => {
        setData(payload || {})
    }, [])

    const onClick = () => {
        const question_details = []
        const keys = Object.keys(data)
        if (keys.length) {
            keys.map(d => {
                const f = schema.find(da => da.name == d)
                if (f) {
                    question_details.push({ question: f.label, answer: data[d] })
                }
            })
            const purpose_queries = { purpose_name, question_details }
            onChange({ purpose_data: data, purpose_queries })
        } else {
            onChange({ purpose_data: data })
        }
    }

    useEffect(() => {
        const btn = document.getElementById("submit")
        btn.addEventListener("click", onClick)

        return () => {
            btn.removeEventListener("click", onClick)
        }
    }, [data])


    return <div>
        {schema.map(d => <FormRow key={d.name} dynamic={true} {...inputProps(d)} />)}
    </div>
}